export type DemoFeatureKey = 'dashboard:project_screener';

export interface DemoSessionConfig {
  feature_key: DemoFeatureKey;
  feature_label: string;
  expires_at: string;
  max_access: number | null;
  access_count: number;
  // Recipient the share link was minted for; used to prefill Contact us.
  email?: string;
}

export interface DemoSessionWireResponse {
  feature_key: DemoFeatureKey | DemoFeatureKey[];
  feature_label: string;
  expires_at: string;
  max_access: number | null;
  access_count: number;
  email?: string;
}

export type DemoErrorCode =
  | 'LINK_NOT_FOUND'
  | 'LINK_EXPIRED'
  | 'LINK_REVOKED'
  | 'LINK_CAP_REACHED'
  | 'LINK_INVALID'
  | 'NETWORK_ERROR';

export class DemoResolveError extends Error {
  code: DemoErrorCode;
  status?: number;
  constructor(code: DemoErrorCode, message: string, status?: number) {
    super(message);
    this.name = 'DemoResolveError';
    this.code = code;
    this.status = status;
  }
}
